import { useFormik } from 'formik';
import { Form } from 'react-bootstrap';
import * as yup from 'yup';

import Button, { ButtonVariant } from '../../../common/button/button';
import styles from './name-step.module.scss';

const NAME_FORM_SCHEMA = yup.object().shape({
  name: yup.string().trim(),
});

export interface Props {
  value?: string;
  onChange: (value: string) => void;
}

const NameStep = ({ value, onChange }: Props) => {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,

    touched,
    errors,
    isValid,
  } = useFormik<{ name: string }>({
    initialValues: { name: value ?? '' },
    validationSchema: NAME_FORM_SCHEMA,
    onSubmit: (values) => {
      onChange(values.name!);
    },
  });

  return (
    <Form className={styles.form} onSubmit={handleSubmit}>
      <Form.Group className={styles.controlGroup}>
        <Form.Control
          placeholder="Name"
          name="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.name && errors.name != null}
        />
        <Form.Control.Feedback type="invalid">
          {errors.name}
        </Form.Control.Feedback>
      </Form.Group>

      <div className={styles.submitButtonContainer}>
        <Button
          type="submit"
          variant={ButtonVariant.SECONDARY}
          onClick={() => {
            onChange('');
          }}>
          I’d stay anonymous
        </Button>

        <Button
          className={styles.submitButton}
          type="submit"
          disabled={!isValid || !values.name}>
          Continue
        </Button>
      </div>
    </Form>
  );
};

export default NameStep;
